import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { SurveyViewerService } from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { Name } from 'app/models/questions/Name'
import { AbstractControl } from '@angular/forms'
import {AuthService} from "../../../../../../core/auth/auth.service";
import {UserService} from "../../../../../../core/user/user.service";

@Component({
  selector: 'app-name',
  templateUrl: './name.component.html',
  styleUrls: ['./name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NameComponent implements IQuestionComponent, OnInit {

  @Input() activeLang: string
  @Input() isSmallScreen: boolean
  @Input() question: Name

  questionFormControl: AbstractControl

  labels = {
    enterFirstName: {
      fr: 'Entrez votre prénom',
      en: 'Enter your first name'
    },
    enterLastName: {
      fr: 'Entrez votre nom de famille',
      en: 'Enter your last name'
    }
  }

  constructor(
    public surveyViewerService: SurveyViewerService,
    public authService: AuthService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form
      .get(this.question.key)
      .get(this.question.rowKeys.pop())
      .get(this.question.commentsControlName)
    if (this.authService.isLogged()){
      this.questionFormControl.get(this.question.firstNameControlName).patchValue(this.userService.user.firstName)
      this.questionFormControl.get(this.question.lastNameControlName).patchValue(this.userService.user.lastName)
    }
    this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl.get(this.question.firstNameControlName), 'blur');
    this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl.get(this.question.lastNameControlName), 'blur');

  }


}
